import { useState, useEffect } from 'react';

// Create a global event system for showing/hiding the loading spinner
type SpinnerAction = 'show' | 'hide';

// Create custom event names
const SPINNER_EVENT = 'loading-spinner';

// Custom events to control the spinner
export const showSpinner = () => {
    const event = new CustomEvent(SPINNER_EVENT, {
        detail: { action: 'show' }
    });

    document.dispatchEvent(event);
};

export const hideSpinner = () => {
    const event = new CustomEvent(SPINNER_EVENT, {
        detail: { action: 'hide' }
    });

    document.dispatchEvent(event);
};

const LoadingSpinner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleSpinnerEvent = (event: Event) => {
            const customEvent = event as CustomEvent<{ action: SpinnerAction }>;

            if (customEvent.detail.action === 'show') {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        // Add event listener for spinner events
        document.addEventListener(SPINNER_EVENT, handleSpinnerEvent);

        // Clean up event listener
        return () => {
            document.removeEventListener(SPINNER_EVENT, handleSpinnerEvent);
        };
    }, []);

    if (!visible) return null;

    return (
        <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-70 flex items-center justify-center z-[9999]"
            id="loadingSpinnerOverlay"
        >
            <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent" />
                <div className="mt-5 text-primary">Loading...</div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
